module.exports = __webpack_public_path__ + "static/img/l-panlm-icon.eb305c6c.png";